<template>
  <component :is="Component" />
</template>

<script>
import NoIntro from './no-intro.vue'
import WithIntro from './with-intro.vue'

export default {
  computed: {
    Component() {
      return this.$root.$data.props.doc.intro ? WithIntro : NoIntro
    }
  }
}
</script>
